module.exports = __webpack_public_path__ + "img/13.748a509f.png";